import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, CanActivate, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { QuoteDataCaptureService } from '../services/api-services/quote-datacapture.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuardGuard implements CanActivate {
  constructor(private quoteDataService: QuoteDataCaptureService,
              private router: Router) {
  }
  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    if (this.quoteDataService.loginDetails) {
      return true;
    } else {
      //this.router.navigate['/quote/please-confirm-your-details'];
      return false;
    }
  }
}
